import React from "react";

interface PrivateEventMarkProps {
  /** Scale factor (1 = 100%) */
  scale?: number;
}

/**
 * Renders the kanji "非" inside a scalable circle mark.
 * - Inherits font from parent, scaled by `scale`.
 * - Circle is 2em at scale=1.
 * - Horizontal margin is 1em at scale=1.
 * - The circle sits behind text without changing line height.
 */
const PrivateEventMark: React.FC<PrivateEventMarkProps> = ({ scale = 1 }) => {
  const fontSize = `${scale}em`;       // scales the glyph
  const circleSize = `${2 * scale}em`; // circle diameter
  const margin = `${1 * scale}em`;     // horizontal margin

  return (
    <span
      style={{
        position: "relative",
        display: "inline-block",
        alignContent: "center",
        textAlign: "center",
        lineHeight: 1,
        marginInline: margin,
        fontSize: fontSize,
        color: "#fff",
        zIndex: 0,
      }}
      aria-label="Private event"
    >
      非
      <span
        aria-hidden
        style={{
          position: "absolute",
          left: "50%",
          top: "50%",
          width: circleSize,
          height: circleSize,
          borderRadius: "50%",
          backgroundColor: "#000",
          transform: "translate(-50%, -50%)",
          zIndex: -1,
          pointerEvents: "none",
        }}
      />
    </span>
  );
};

export default PrivateEventMark;
